import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/system';

var MarginContainer = styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 auto;\n  max-width: 1430px;\n  @media (min-width: ", "px) {\n    padding: 0 22px;\n  }\n  padding: 0 2px 0;\n  width: 100%;\n"], ["\n  margin: 0 auto;\n  max-width: 1430px;\n  @media (min-width: ", "px) {\n    padding: 0 22px;\n  }\n  padding: 0 2px 0;\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.md;
});
var PageContainer = styled(MarginContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media (min-width: ", "px) {\n    padding: 52px 22px 40px;\n  }\n  padding: 52px 4px 40px;\n"], ["\n  @media (min-width: ", "px) {\n    padding: 52px 22px 40px;\n  }\n  padding: 52px 4px 40px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.md;
});
var templateObject_1, templateObject_2;

export { MarginContainer, PageContainer };
